<p-fluid>
  <form [formGroup]="transactionForm" class="flex flex-col gap-4 mt-2 mb-4">
    <p-togglebutton
      formControlName="isIncome"
      [onLabel]="'internal.finances.transaction.income' | translate"
      [offLabel]="'internal.finances.transaction.notincome' | translate"
    />
    <p-togglebutton
      formControlName="pending"
      [onLabel]="'internal.finances.transaction.pending' | translate"
      [offLabel]="'internal.finances.transaction.notpending' | translate"
    />

    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="reason"
        [invalid]="
          transactionForm.controls.reason.invalid && transactionForm.controls.reason.touched
        "
        autocomplete="off"
      />
      <label>{{ 'internal.finances.transaction.reason' | translate }}</label>
    </p-floatlabel>

    <div class="desktop">
      <label>{{ 'internal.finances.transaction.date' | translate }}</label>
      <p-datepicker
        formControlName="date"
        [invalid]="transactionForm.controls.date.invalid && transactionForm.controls.date.touched"
        showIcon
        iconDisplay="input"
        [showTime]="true"
        [inline]="true"
          [showButtonBar]="true"
        hourFormat="24"
      />
    </div>

    <p-floatlabel variant="on" class="mobile">
      <p-datepicker
        formControlName="date"
        [invalid]="transactionForm.controls.date.invalid && transactionForm.controls.date.touched"
        showIcon
        iconDisplay="input"
        [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
        hourFormat="24"
      />
      <label>{{ 'internal.finances.transaction.date' | translate }}</label>
    </p-floatlabel>

    @if (loadingUsers()) {
      <p-skeleton height="2.625rem"/>
    } @else {
      <p-floatlabel variant="on">
        <p-autocomplete
          [formControl]="userControl"
          [suggestions]="filteredUsers()"
          (completeMethod)="_searchUser($event)"
          [lazy]="true"
          [completeOnFocus]="true"
          dataKey="_id"
          optionLabel="fullname"
        />
        <label>{{ 'internal.finances.transaction.user' | translate }}</label>
      </p-floatlabel>
    }

    @if (loadingEvents()) {
      <p-skeleton height="2.625rem"/>
    } @else {
      <p-floatlabel variant="on">
        <p-autocomplete
          [formControl]="eventControl"
          [suggestions]="filteredEvents()"
          (completeMethod)="_searchEvent($event)"
          [lazy]="true"
          [completeOnFocus]="true"
          dataKey="_id"
          optionLabel="name"
        />
        <label>{{ 'internal.finances.transaction.event' | translate }}</label>
      </p-floatlabel>
    }

    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="notes"
        [invalid]="transactionForm.controls.notes.invalid && transactionForm.controls.notes.touched"
        autocomplete="off"
      />
      <label>{{ 'internal.finances.transaction.notes' | translate }}</label>
    </p-floatlabel>

    <p-floatlabel variant="on">
      <p-inputnumber
        formControlName="amount"
        [invalid]="
          transactionForm.controls.amount.invalid && transactionForm.controls.amount.touched
        "
        mode="currency"
        currency="EUR"
        locale="de-DE"
      />
      <label>{{ 'internal.finances.transaction.amount' | translate }}</label>
    </p-floatlabel>

    <div class="form-subtitle">
      {{ 'internal.finances.transaction.attachments' | translate }}
    </div>

    <document-grid
      [urlTemplate]="apiUrl + 'finances/transactions/' + transaction._id + '/file/<filename>'"
      [documents]="allFiles()"
      [showUpload]="true"
      [showDownload]="true"
      [showView]="true"
      [showDelete]="true"
      (uploadClicked)="uploadFile($event)"
      (deleteClicked)="deleteFile($event)">
    </document-grid>
  </form>
</p-fluid>

<div class="flex justify-end gap-2">
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="!transactionForm.valid"
    (onClick)="closeDialog(true)"
  />
</div>
